import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the RealTimeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RealTimeProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello RealTimeProvider Provider');
  }

  switchFuncRealTimeQuotes(is_switch: boolean) {
    return this.http.hPost('/quotes/switch_func_real_time_quotes', {
      switch: is_switch,
    });
  }

  getRealTimeQuotesList(page, pagesize) {
    let params = {
      page: page,
      pagesize: pagesize,
    };
    return this.http.hPost('/quotes/get_rt_quotes_list_and_status', params);
  }

  getRealTimeQuotesStatus() {
    return this.http.hPost('/quotes/get_func_real_time_quotes_status');
  }

  getCoinPreview(coin_id) {
    return this.http.hPost('/quotes/get_rt_quotes_preview', { coin_id: coin_id });
  }
}



// WEBPACK FOOTER //
// ./src/providers/real-time/real-time.ts